
import { requireAuth } from './auth';
const baseURL = process.env.VUE_APP_API_BASE_URL;

function buildAdminFileUrl(fileId) {
    const url = new URL(`${baseURL}/files/DownloadAdminFile`);
    url.searchParams.append('audioFileId', fileId);
    return url.toString();
}

async function responseErrorMessage(response, fallbackMessage) {
    const retryAfter = response.headers.get('Retry-After');
    let message = fallbackMessage;

    try {
        const data = await response.clone().json();
        const detail = data?.detail;
        if (typeof detail === 'string') {
            message = detail;
        } else if (detail?.error) {
            message = detail.error;
        }
    } catch (_) {
        try {
            const text = await response.clone().text();
            if (text) message = text;
        } catch (_) {
            // Keep the fallback message when the response body is not readable text.
        }
    }

    if (response.status === 429) {
        const retryText = retryAfter ? ` Try again in ${retryAfter}s.` : ' Try again shortly.';
        message = `Too many download requests.${retryText}`;
    }

    return message;
}

async function fetchBlob(url, options, fallbackMessage) {
    const response = await fetch(url, options);
    if (!response.ok) {
        const error = new Error(await responseErrorMessage(response, fallbackMessage));
        error.status = response.status;
        error.retryAfter = response.headers.get('Retry-After');
        throw error;
    }
    return await response.blob();
}

async function fetchJson(url, options, fallbackMessage) {
    const response = await fetch(url, options);
    if (!response.ok) {
        const error = new Error(await responseErrorMessage(response, fallbackMessage));
        error.status = response.status;
        error.retryAfter = response.headers.get('Retry-After');
        throw error;
    }
    return await response.json();
}

export async function downloadFile(audioFileId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/files/DownloadFile`);
    url.searchParams.append('audioFileId', audioFileId);
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        });
        if (!response.ok) {
            const error = new Error(await responseErrorMessage(response, 'DownloadFile failed'));
            error.status = response.status;
            error.retryAfter = response.headers.get('Retry-After');
            throw error;
        }
        return await response.blob();
    } catch (error) {
        console.error('downloadFile failed:', error);
        throw error;
    }
}

export async function getDownloadFileUrl(audioFileId, expiresIn = 300) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/files/GetDownloadFileUrl`);
    url.searchParams.append('audioFileId', audioFileId);
    url.searchParams.append('expiresIn', expiresIn);
    try {
        return await fetchJson(url, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        }, 'GetDownloadFileUrl failed');
    } catch (error) {
        console.error('GetDownloadFileUrl failed:', error);
        throw error;
    }
}

export async function downloadDemoFile(model, voice) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    var audioFileId = '';
    if (model == 'Kokoro v1.0') {
        audioFileId = `Kokoro-v1.0_${voice}-demo.wav`;
    }
    const url = new URL(`${baseURL}/files/DownloadAdminFile`);
    url.searchParams.append('audioFileId', audioFileId);
    try {
        return await fetchBlob(url, {
            method: "GET",
            headers: {
                // 'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        }, 'DownloadAdminFile failed');
    } catch (error) {
        console.error('DownloadAdminFile failed:', error);
        throw error;
    }
}

export function getVoiceProfilePicUrl(model, voice) {
    if (model == 'Kokoro v1.0') {
        return buildAdminFileUrl(`Kokoro-v1.0_${voice}-demo.png`);
    }
    return '';
}

export async function downloadVoiceProfilePics(model, voice) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    var FileId = '';
    if (model == 'Kokoro v1.0') {
        FileId = `Kokoro-v1.0_${voice}-demo.png`;
    }

    const url = new URL(`${baseURL}/files/DownloadAdminFile`);
    url.searchParams.append('audioFileId', FileId);
    try {
        return await fetchBlob(url, {
            method: "GET",
            headers: {
                // 'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        }, 'DownloadAdminFile failed');
    } catch (error) {
        console.error('DownloadAdminFile failed:', error);
        throw error;
    }
}
